export const hasRole = (role, storedRoles = localStorage.getItem('roles')) => {
  try {
    const roles = JSON.parse(storedRoles || '[]');
    return Array.isArray(roles) && roles.some(value => String(value).toUpperCase() === role.toUpperCase());
  } catch { return false; }
};
